module.exports = __webpack_public_path__ + "img/manhattan-fomento-mercantil.9aac59e6.png";